export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-arrow-down-66ba0e44719b487c23921347ca52736c.svg";